<template>
  <div>
    <Breadcrumbs primary="Регистрация" secondary="Завершение"/>
    <FinalizeRegistrationForm :paths="paths" />
  </div>
</template>

<script>
import FinalizeRegistrationForm from "@shared/components/registration/finalize.component"



export default {
  name: "FinalizeRegistration",
  title: "Завершение регистрации",
  components: {FinalizeRegistrationForm},
  data(){
    return {
      paths: {
        savePath: "/user/finalizeRegistration",
        redirectPath: "/cab/messages/new_send"
      }
    }
  }
}

</script>